import React, { useContext } from 'react';
import '../../../styles/irctcForgotUserNameForm.css';
import '../../../styles/railSeoSprite.css';
import FacingTrouble from '../../components/FacingTrouble';
import InputField from '../../components/InputField';
import { checkValidation, validations } from '../../../utils/FormValidators';
import IrctcDatePicker from '../../components/IrctcDatePicker';
import {
  FACING_TROUBLE_PAGE_TITLE,
  getFacingTroubleList,
  IRCTC_DATE_LIMITS,
  IRCTC_FORGOT_USERNAME_COMPONENTS,
  SERVER_URL
} from '../../../utils/RailsSEOConstants';
import fecha from 'fecha';
import axios from 'axios';
import { IrctcForgotUsernameContext } from '../IrctcForgotUserNamePage';
import * as irctcForgotUsernameActions from './../../../actions/irctcForgotUsernameActions';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/commonUtils';

const IrctcForgotUserNameForm = (props) => {
  const isMobileDevice = isMobile();
  const { customClass } = props;
  const context = useContext(IrctcForgotUsernameContext);
  const {
    forgotUserNameState: { userEmail, selectedDate, showErrorInputForm, submitFailedErrorMessage },
    forgotUserNameDispatch
  } = context;
  const updateShowErrorInputForm = (latestShowError) => {
    forgotUserNameDispatch({
      type: irctcForgotUsernameActions.ACTION_SET_SHOW_ERROR_INPUT_FORM,
      data: latestShowError
    });
  };
  const updateComponentToShow = (latestValue) => {
    forgotUserNameDispatch({
      type: irctcForgotUsernameActions.ACTION_SET_COMPONENT_TO_SHOW_FORGOT_USERNAME,
      data: latestValue
    });
  };
  const updateSubmitFailedErrorMessage = (latestMessage) => {
    forgotUserNameDispatch({
      type: irctcForgotUsernameActions.ACTION_SET_SUBMIT_FAILED_ERR_MSG_FORGOT_USERNAME,
      data: latestMessage
    });
  };
  const updateUserEmail = (latestUserEmail) => {
    if (submitFailedErrorMessage) {
      updateSubmitFailedErrorMessage('');
    }
    forgotUserNameDispatch({
      type: irctcForgotUsernameActions.ACTION_SET_USER_EMAIL_FORGOT_USERNAME,
      data: latestUserEmail
    });
  };
  const updateSelectedDate = (latestSelectedDate) => {
    if (submitFailedErrorMessage) {
      updateSubmitFailedErrorMessage('');
    }
    forgotUserNameDispatch({
      type: irctcForgotUsernameActions.ACTION_SET_SELECTED_DATE_FORGOT_USERNAME,
      data: latestSelectedDate
    });
  };
  const isErrorPresentInFields = () => {
    return !selectedDate || !checkValidation(userEmail, validations.email);
  };
  const forgotUserNameApiCall = async () => {
    try {
      // make API request
      const res = await axios.get(`${SERVER_URL}/user/irctc/details/U`, {
        params: {
          userLoginId: '',
          email: userEmail || '',
          mobile: '',
          otpType: '',
          dob: fecha.format(selectedDate, 'YYYYMMDD') || ''
        }
      });

      // check API response
      // if user has not filled the correct information show error else form submitted successfully
      if (res.data.error) {
        updateSubmitFailedErrorMessage(
          'Email is not registered with IRCTC or Date of birth didn’t match the information in your IRCTC account.'
        );
      } else {
        updateSubmitFailedErrorMessage('');
        updateComponentToShow(IRCTC_FORGOT_USERNAME_COMPONENTS.successPage);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const handleForgotUserNameFormSubmit = async () => {
    if (isErrorPresentInFields()) {
      updateShowErrorInputForm(true);
    } else {
      updateShowErrorInputForm(false); // No Validation Errors
      await forgotUserNameApiCall();
    }
  };

  return (
    <div className={`${customClass} getIrctcUserNmComp`}>
      <div className="getIrctcPwd__cntnt">
        <h4>Email Address Registered with IRCTC</h4>
        <InputField
          value={userEmail}
          updateParentValue={updateUserEmail}
          placeholder="Enter Email Id"
          customClass="appendBottom30"
          error={showErrorInputForm && !checkValidation(userEmail, validations.email)}
          errorMsg={'Enter a valid email address'}
        />
        <h4>Date of Birth</h4>
        <IrctcDatePicker
          placeholder="Select a Date"
          selectedDay={selectedDate}
          fromDate={IRCTC_DATE_LIMITS.fromDate}
          toDate={IRCTC_DATE_LIMITS.toDate}
          updateParentDate={updateSelectedDate}
          error={!!submitFailedErrorMessage || (showErrorInputForm && !selectedDate)}
          errorMsg={submitFailedErrorMessage || 'Enter a vaild date of birth'}
          customClass="appendBottom30"
        />
        <button
          className={`blueButtonRails ${isMobileDevice ? 'fullWidth' : ''} append_bottom20`}
          onClick={handleForgotUserNameFormSubmit}
        >
          GET USERNAME ON EMAIL
        </button>
        <p>You will receive an Email from IRCTC with your Username.</p>
      </div>
      <FacingTrouble
        customClass={'appendTop30'}
        facingTroubleList={getFacingTroubleList(FACING_TROUBLE_PAGE_TITLE.FORGOT_IRCTC_USERNAME_TITLE)}
      />
    </div>
  );
};

IrctcForgotUserNameForm.propTypes = {
  customClass: PropTypes.string
};

export default IrctcForgotUserNameForm;
